// eslint-disable-next-line import/no-unused-modules
import * as React from 'react';

export interface IClickableProps {
	onClick?: (event: React.MouseEvent) => void;
	disabled?: boolean;
}

export interface IButtonProps extends IClickableProps {
	fullWidth?: boolean;
	value?: string;
	size?: ButtonSize;
	color?: string;
	indication?: ButtonIndication;
	disabled?: boolean;
}

export interface IButtonPropsExtended extends IButtonProps {
	py?: number;
	px?: number;
}

export enum ButtonIndication {
	Default,
	Danger,
	Warning,
	Success,
}

export enum ButtonSize {
	Large,
	Medium,
	Small,
}
